import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectCartOpenStatus = createSelector(
  [(state: RootState) => state.cart.isOpen],
  status => status
);
export const selectCartAddToCartStatus = createSelector(
  [(state: RootState) => state.cart.isAddingToCart],
  status => status
);
